import { useRef } from 'react';

/**
 * Most likely to be used when deleting elements in a list.
 * Often, the browser will  manage keyboard focus well, unless the _last_
 * item gets deleted, or the delete button disappears. In that case, move focus
 * to a reasonable element, e.g. a nearby `Add item` button.
 */
export const useMoveFocus = <T extends HTMLElement = HTMLButtonElement>() => {
  const focusCatcherRef = useRef<T>(null);
  const moveFocus = () => focusCatcherRef.current?.focus();

  return { moveFocus, focusCatcherRef };
};
